export const BLOCK_OPACITY_TIME = 0.5;
export const BLOCK_TRANSFORM_TIME = 0.5;
//# sourceMappingURL=constants.js.map